<div class="d-flex justify-content-center align-items-center">
  <p class="m-0 me-2 text-muted" [class]="class"><small>Bezig met laden...</small></p>
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Begin met laden...</span>
  </div>
</div>
